<script>
export default {
  name: 'CountDownBtn',
  render(h) {
    const {
      disabled,
      locked,
      clicked,
      clickTips,
      el,
      handlerClick,
      tips,
      placeholder
    } = this
    return h(
      el,
      {
        class: {
          'count-down-btn': true,
          disabled,
          locked,
          clicked
        },
        on: {
          click(e) {
            e.preventDefault()
            handlerClick()
          }
        }
      },
      clicked ? clickTips : locked ? tips : placeholder
    )
  },
  props: {
    time: {
      type: Number,
      default: 60
    },
    placeholder: {
      type: String,
      default: '获取验证码'
    },
    clickTips: {
      type: String,
      default: '已点击'
    },
    lockTmp: {
      type: String,
      default: '倒计时%s秒'
    },
    el: {
      type: String,
      default: 'a'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      clicked: false,
      locked: false,
      currSec: 0
    }
  },
  computed: {
    tips() {
      return this.lockTmp.replace(/%s/g, this.currSec)
    }
  },
  methods: {
    handlerClick() {
      if (this.disabled || this.clicked || this.locked) return
      this.clicked = true
      this.$emit('click', this.lock, this.reset)
    },
    lock(setTime = this.time) {
      console.log('开始倒计时')
      if (this.t) clearInterval(this.t)
      this.locked = true
      this.$emit('disabled:update', true)
      this.clicked = false
      this.currSec = setTime
      this.t = setInterval(() => {
        this.currSec--
        if (this.currSec === 0) {
          this.reset()
        }
      }, 1000)
    },
    reset() {
      if (this.t) clearInterval(this.t)
      this.clicked = this.locked = false
      this.$emit('disabled:update', false)
      this.t = null
    }
  },
  destroyed() {
    this.reset()
  }
}
</script>
<style lang="scss" scoped>
.locked,
.clicked,
.disabled {
  border-color: #ededed;
  background: #ededed !important;
  cursor: not-allowed;
  color: white;
  &:focus,
  &:hover {
    border-color: #ededed;
  }
}
</style>
